module.exports = __webpack_public_path__ + "img/figure-13.cd1b9745.png";